import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export const UserContext = createContext({ user: undefined });

export const UserProviderRaw = ({ children, adminUser }) => {

  return (
    <UserContext.Provider value={ { user: adminUser } } >
      { children }
    </UserContext.Provider>
  );
};

UserProviderRaw.displayName = "UserProvider";
UserProviderRaw.propTypes = {
  children: PropTypes.object.isRequired,
  adminUser: PropTypes.object
};

export const AuthConsumer = UserContext.Consumer;

export const UserProvider = connect(
  (state => ({
    adminUser: state.authStatus && state.authStatus.user ? state.authStatus.user : null
  })),
)(UserProviderRaw)



// WEBPACK FOOTER //
// ./webAdmin/contexts/authUser.js